import React, { useCallback, useState } from "react";
import Container from "@mui/material/Container";
import AppBar from "@components/AppBar";
import Footer from "@components/Footer";
import Box from "@mui/material/Box";
import "./styles.css";
import { useExtendedTheme } from "@theme/Context";
import { graphql, PageProps, useStaticQuery } from "gatsby";
import Loading from "./Loading";
import AnimatedAvatar from "./Loading/AnimatedAvatar";
import { fadeInAnimation } from "./Loading/AnimatedAvatar/styles";

const loadingQuery = graphql`
  query LoadingQuery {
    avatar: contentfulAsset(title: { eq: "avatar" }) {
      title
      url
      description
    }
  }
`;

const ResponsiveLayout = (props: PageProps & React.PropsWithChildren) => {
  const { theme } = useExtendedTheme();
  const [showLoading, setShowLoading] = useState(true);
  const layoutData = useStaticQuery<{
    avatar: {
      title: string;
      url: string;
      description: string;
    };
  }>(loadingQuery);
  const avatar = layoutData.avatar;

  const onLoaded = useCallback(() => {
    setShowLoading(false);
  }, []);

  const loadingAnimationDurationInMs = 1000;
  const closeAnimationDurationInMs = 1500;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        bgcolor: theme.palette.background.default,
      }}
    >
      <Loading
        show={showLoading}
        onLoaded={onLoaded}
        chunkCount={3}
        durationInMs={loadingAnimationDurationInMs}
        closeDelayInMs={closeAnimationDurationInMs}
      >
        <AnimatedAvatar
          src={avatar.url}
          alt={avatar.title}
          animationDurationInMs={loadingAnimationDurationInMs}
        />
      </Loading>

      {!showLoading && (
        <>
          <AppBar path={props.path} />
          <main>
            <Container
              sx={{
                py: 2,
                animation: `${fadeInAnimation} ${
                  closeAnimationDurationInMs / 1000
                }s ease`,
              }}
              maxWidth="lg"
            >
              {props.children}
            </Container>
          </main>
          <Footer />
        </>
      )}
    </Box>
  );
};

export default ResponsiveLayout;
